import BlogContent from '@/blog/infrastructure/views/BlogContent.vue';
import { RouteRecordRaw } from 'vue-router';

export const blogRouter: Array<RouteRecordRaw> = [
  {
    path: '/blog',
    name: 'Blog',
    component: BlogContent,
    meta: {
      layout: 'DefaultPage',
      theme: 'light'
    }
  },
];
